import { render, staticRenderFns } from "./COffline.vue?vue&type=template&id=687e3432&scoped=true"
import script from "./COffline.vue?vue&type=script&lang=js"
export * from "./COffline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687e3432",
  null
  
)

export default component.exports